import {API_URL, CMS_URL, numberWithCommas, THEME_COLOR, zerofill} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { Card, CardMedia, CardContent, Divider,CardHeader } from "@mui/material";
import Typography from '@mui/material/Typography';
import DownloadOutlined from '@mui/icons-material/DownloadOutlined'
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import Link from "@mui/material/Link";
import banner1 from "../logo.svg"
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import toast, { Toaster } from 'react-hot-toast';
// import { Link } from "react-router-dom";

import CENA from "../images/bank/Bank_Central_Asia.png";
import BMRI from "../images/bank/Bank_Mandiri.png";
import BBBA from "../images/bank/Bank_Permata.png";
import BNIN from "../images/bank/BNI.png";
import BRIN from "../images/bank/BRI.png";
import BNIA from "../images/bank/CIMB.png";
import BDIN from "../images/bank/Danamon.png";
import HNBN from "../images/bank/KEB-Hana.png";
import IBBK from "../images/bank/Maybank.png";

const PaymentInfo = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [id, setId] = useState(0);
    const [vadetail,setVADetail] = useState({});
    const [timer, setTimer] = useState("");

    function getVAData(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/vadetail/${props.match.params.id}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initData(){
        let response = await getVAData();
        if(response && response.status == 200){
            setVADetail(response.data);
            CountDownTimer(response.data)
            document.getElementById(response.data.Bank_Name).style.display = "block";
        }
    }

    const getPicture = (vadetail)=>{
        if(vadetail.Bank_Name == "CENA") return CENA;
        else if(vadetail.Bank_Name == "BMRI") return BMRI;
        else if(vadetail.Bank_Name == "BBBA") return BBBA;
        else if(vadetail.Bank_Name == "BNIN") return BNIN;
        else if(vadetail.Bank_Name == "BRIN") return BRIN;
        else if(vadetail.Bank_Name == "BNIA") return BNIA;
        else if(vadetail.Bank_Name == "BDIN") return BDIN;
        else if(vadetail.Bank_Name == "HNBN") return HNBN;
        else if(vadetail.Bank_Name == "IBBK") return IBBK;
    }

    const getBankName = (vadetail)=>{
        if(vadetail.Bank_Name == "CENA") return "Bank Central Asia";
        else if(vadetail.Bank_Name == "BMRI") return "Bank Mandiri";
        else if(vadetail.Bank_Name == "BBBA") return "Bank Permata";
        else if(vadetail.Bank_Name == "BNIN") return "Bank Nasional Indonesia";
        else if(vadetail.Bank_Name == "BRIN") return "Bank Rakyat Indonesia";
        else if(vadetail.Bank_Name == "BNIA") return "CIMB Niaga";
        else if(vadetail.Bank_Name == "BDIN") return "Bank Danamon";
        else if(vadetail.Bank_Name == "HNBN") return "Bank KEB Hana";
        else if(vadetail.Bank_Name == "IBBK") return "Bank Maybank";
    }

    const getDueDate = (vadetail)=>{
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
        if(vadetail.Log){
            let validdate = JSON.parse(vadetail.Log);
            let vavalidtm = validdate.vacctValidTm;
            validdate = validdate.vacctValidDt;

            let date = new Date(validdate.substring(0,4), validdate.substring(4,6) - 1,validdate.substring(6,8), vavalidtm.substring(0,2),vavalidtm.substring(2,4),vavalidtm.substring(4,6));
            return `${days[date.getDay()]}, ${zerofill(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()}`;
        }
    }

    function goHome(){
        window.history.replaceState(null, null, `/`);
        window.location.reload();
    }

    function CountDownTimer(vadetail)
    {
        // if(vadetail.Log){
        // }
        let validdate = JSON.parse(vadetail.Log);
        let vavalidtm = validdate.vacctValidTm;
        validdate = validdate.vacctValidDt;

        // end = new Date(validdate.substring(0,4), validdate.substring(4,6) - 1,validdate.substring(6,8), vavalidtm.substring(0,2),vavalidtm.substring(2,4),vavalidtm.substring(4,6));
        var end = new Date(validdate.substring(0,4), validdate.substring(4,6) - 1,validdate.substring(6,8), vavalidtm.substring(0,2),vavalidtm.substring(2,4),vavalidtm.substring(4,6));
        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;
        var timer;
        function showRemaining() {
            var now = new Date();
            var distance = end - now;
            if (distance < 0) {
                clearInterval(timer);
                // document.getElementById(id).innerHTML = '<b>Virtual Account Expired</b> ';
                setTimer(<b>Virtual Account Expired</b>);
                return;
            }
            var days = zerofill(Math.floor(distance / _day));
            var hours = zerofill(Math.floor((distance % _day) / _hour));
            var minutes = zerofill(Math.floor((distance % _hour) / _minute));
            var seconds = zerofill(Math.floor((distance % _minute) / _second));

            // document.getElementById(id).innerHTML = days + ':';
            // document.getElementById(id).innerHTML += hours + ':';
            // document.getElementById(id).innerHTML += minutes + ':';
            // document.getElementById(id).innerHTML += seconds;
            setTimer(`${days} : ${hours} : ${minutes} : ${seconds}`)
        }
        timer = setInterval(showRemaining, 1000);
    }

    useEffect(()=>{
        setId(props.match.params.id);
        initData();
    },[])

    return (
        <div style={{backgroundColor:"white", padding:"10px"}}>
            <Toaster
                position="bottom-center"
            />
            <Stack direction="column" sx={{textAlign:"center"}}>
                <Typography variant="h5" component="h5" mt={10}>Do Payment Before</Typography>
                <Typography sx={{color:"red", fontSize:"14pt", fontWeight:"bold"}}>{timer}</Typography>
                <Typography sx={{color:"gray", fontSize:"12pt",}}>Payment Due</Typography>
                <Typography variant="h5" component="h5">{getDueDate(vadetail)}</Typography>
            </Stack>
            <Card sx={{marginTop:"20px"}}>
                <Stack direction="row" sx={{padding:"10px"}} spacing={2}>
                    <img src={getPicture(vadetail)} style={{width: "100px"}} />
                    <Typography sx={{fontSize:"16pt", fontWeight:"bold"}}>{getBankName(vadetail)}</Typography>
                </Stack>
                <Divider />
                <Stack direction="column" sx={{padding:"10px"}} justifyItems="center">
                    <Stack direction="row" justifyItems="center">
                        <Typography variant="h6" sx={{flexGrow:"1"}}>VA Number</Typography>
                        <Typography variant="h6" sx={{color:"#ff3d00"}}>
                            <CopyToClipboard text={vadetail.VirtualAccountNo}
                                onCopy={() => toast.success("copied to clipboard")}>
                                    <span style={{"cursor":"pointer"}} >
                                        <i className="tiny material-icons prefix">content_copy</i>
                                    </span>
                            </CopyToClipboard>
                            {vadetail.VirtualAccountNo}
                        </Typography>
                    </Stack>
                    <Stack direction="row" justifyItems="center">
                        <Typography variant="h6" sx={{flexGrow:"1"}}>Total Payment</Typography>
                        <Typography variant="h6" sx={{color:"#ff3d00"}}>{numberWithCommas(vadetail.Amount)}</Typography>
                    </Stack>
                </Stack>
            </Card>
            <Stack direction="row" justifyContent="center" mt={8} spacing={2}>
                <button className={`btn`} style={{minWidth:"100px", backgroundColor:"white", color:"#ff3d00", border:"1px solid #ff3d00"}} onClick={()=>{window.location.reload()}}>
                    Payment Status
                </button>
                <button className={`btn ${THEME_COLOR}`} style={{minWidth:"100px"}} onClick={()=>{goHome()}}>
                    Shop More
                </button>
            </Stack>
            <div id="CENA" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>BCA</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Transaksi Lainnya<br/>
                3. Pilih Transfer<br/>
                4. Pilih Ke rekening BCA Virtual Account<br/>
                5. Input Nomor Virtual Account, misal. 123456789012XXXX<br/>
                6. Pilih Benar<br/>
                7. Pilih Ya<br/>
                8. Ambil bukti bayar Anda<br/>
                9. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Mobile Banking<br/>
                2. Pilih m-Transfer<br/>
                3. Pilih BCA Virtual Account<br/>
                4. Input Nomor Virtual Account, misal. 123456789012XXXX sebagai No. Virtual Account<br/>
                5. Klik Send<br/>
                6. Informasi Virtual Account akan ditampilkan<br/>
                7. Klik OK<br/>
                8. Input PIN Mobile Banking<br/>
                9. Bukti bayar ditampilkan<br/>
                10. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Transaksi Dana<br/>
                3. Pilih Transfer Ke BCA Virtual Account<br/>
                4. Input Nomor Virtual Account, misal. 123456789012XXXX sebagai No. Virtual Account<br/>
                5. Klik Lanjutkan<br/>
                6. Input Respon KeyBCA Appli 1<br/>
                7. Klik Kirim<br/>
                8. Bukti bayar ditampilkan<br/>
                9. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BMRI" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>Mandiri</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Bayar/Beli<br/>
                3. Pilih Lainnya<br/>
                4. Pilih Multi Payment<br/>
                5. Input 70014 sebagai Kode Institusi<br/>
                6. Input Virtual Account Number, misal. 70014XXXXXXXXXXX<br/>
                7. Pilih Benar<br/>
                8. Pilih Ya<br/>
                9. Pilih Ya<br/>
                10. Ambil bukti bayar Anda<br/>
                11. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Mobile Banking<br/>
                2. Pilih Bayar<br/>
                3. Pilih Multi Payment<br/>
                4. Input Transferpay sebagai Penyedia Jasa<br/>
                5. Input Nomor Virtual Account, misal. 70014XXXXXXXXXXX<br/>
                6. Pilih Lanjut<br/>
                7. Input OTP and PIN<br/>
                8. Pilih OK<br/>
                9. Bukti bayar ditampilkan<br/>
                10. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Bayar<br/>
                3. Pilih Multi Payment<br/>
                4. Input Transferpay sebagai Penyedia Jasa<br/>
                5. Input Nomor Virtual Account, misal. 70014XXXXXXXXXXX sebagai Kode Bayar<br/>
                6. Ceklis IDR<br/>
                7. Klik Lanjutkan<br/>
                8. Bukti bayar ditampilkan<br/>
                9. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BNIN" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>BNI</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Masukkan Kartu Anda.<br/>
                2. Pilih Bahasa.<br/>
                3. Masukkan PIN ATM Anda.<br/>
                4. Pilih "Menu Lainnya".<br/>
                5. Pilih "Transfer".<br/>
                6. Pilih Jenis rekening yang akan Anda gunakan (Contoh; "Dari Rekening Tabungan").<br/>
                7. Pilih “Virtual Account Billing”<br/>
                8. Masukkan Nomor Virtual Account Anda (contoh: 123456789012XXXX).<br/>
                9. Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi.<br/>
                10. Konfirmasi, apabila telah sesuai, lanjutkan transaksi.<br/>
                11. Transaksi Anda telah selesai.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Akses BNI Mobile Banking dari handphone kemudian masukkan user ID dan password.<br/>
                2. Pilih menu “Transfer”.<br/>
                3. Pilih menu “Virtual Account Billing” kemudian pilih rekening debet.<br/>
                4. Masukkan Nomor Virtual Account Anda (contoh: 123456789012XXXX) pada menu “input baru”.<br/>
                5. Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi.<br/>
                6. Konfirmasi transaksi dan masukkan Password Transaksi.<br/>
                7. Pembayaran Anda Telah Berhasil.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>iBank Personal BNI</strong><br/>
                Panduan Bayar<br/>
                1. Ketik alamat https://ibank.bni.co.id kemudian klik “Enter”.<br/>
                2. Masukkan User ID dan Password.<br/>
                3. Pilih menu “Transfer”.<br/>
                4. Pilih “Virtual Account Billing”.<br/>
                5. Kemudian masukan Nomor Virtual Account Anda (contoh: 123456789012XXXX) yang hendak dibayarkan. Lalu pilih rekening debet yang akan digunakan. Kemudian tekan ‘’lanjut’’.<br/>
                6. Kemudin tagihan yang harus dibayarkan akan muncul pada layar konfirmasi.<br/>
                7. Masukkan Kode Otentikasi Token.<br/>
                8. Pembayaran Anda telah berhasil.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>BNI sms banking</strong><br/>
                Panduan Bayar<br/>
                1. Buka aplikasi SMS Banking BNI.<br/>
                2. Pilih menu Transfer.<br/>
                3. Pilih menu Trf rekening BNI.<br/>
                4. Masukkan Nomor rekening tujuan dengan 16 digit Nomor Virtual Account (contoh: 123456789012XXXX).<br/>
                5. Masukkan Nominal transfer sesuai tagihan atau kewajiban Anda. Nominal yang berbeda tidak dapat diproses.<br/>
                6. Pilih “Proses” kemudian “Setuju”.<br/>
                7. Reply sms dengan ketik pin sesuai perintah.<br/>
                8. Transaksi Berhasil.<br/>
                <br/>
                Atau Dapat juga langsung mengetik sms dengan format:<br/>
                TRF[SPASI]NomorVA[SPASI]NOMINAL<br/>
                dan kemudian kirim ke 3346<br/>
                Contoh : TRF 123456789012XXXX 44000<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>ATM Bersama</strong><br/>
                Panduan Bayar<br/>
                1. Masukkan kartu ke mesin ATM Bersama.<br/>
                2. Pilih "Transaksi Lainnya".<br/>
                3. Pilih menu "Transfer".<br/>
                4. Pilih "Transfer ke Bank Lain".<br/>
                5. Masukkan kode bank BNI (009) dan 16 Digit Nomor Virtual Account (contoh: 123456789012XXXX).<br/>
                6. Masukkan nominal transfer sesuai tagihan atau kewajiban Anda. Nominal yang berbeda tidak dapat diproses.<br/>
                7. Konfirmasi rincian Anda akan tampil di layar, cek dan tekan 'Ya' untuk melanjutkan.<br/>
                8. Transaksi Berhasil.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>Bank Lain</strong><br/>
                Panduan Bayar<br/>
                1. Pilih menu "Transfer antar bank" atau “Transfer online antarbank”.<br/>
                2. Masukkan kode bank BNI (009) atau pilih bank yang dituju yaitu BNI.<br/>
                3. Masukan 16 Digit Nomor Virtual Account pada kolom rekening tujuan, (contoh: 123456789012XXXX).<br/>
                4. Masukkan Nominal transfer sesuai tagihan atau kewajiban Anda. Nominal yang berbeda tidak dapat diproses.<br/>
                5. Masukkan jumlah pembayaran (contoh: 44000).<br/>
                6. Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan lanjutkan transaksi sampai dengan selesai.<br/>
                7. Transaksi Berhasil.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"3%"}}>
                <strong>OVO</strong><br/>
                Panduan Bayar<br/>
                1. Buka aplikasi OVO<br/>
                2. Pilih menu Transfer<br/>
                3. Pilih “Rekening Bank”<br/>
                4. Masukkan kode bank BNI (009) atau pilih bank yang dituju yaitu BNI.<br/>
                5. Masukan 16 Digit Nomor Virtual Account pada kolom rekening tujuan, (contoh: 123456789012XXXX).<br/>
                6. Masukkan Nominal transfer sesuai tagihan atau kewajiban Anda.<br/>
                7. Pilih “Transfer”.<br/>
                8. Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan pilih “Konfirmasi” untuk lanjutkan transaksi sampai dengan selesai.<br/>
                9. Transaksi Berhasil.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
            </div>
        </div>
    </div>
</div>
</div>

<div id="IBBK" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>MAYBANK</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Transfer<br/>
                3. Pilih Virtual Account<br/>
                4. Input Nomor Virtual Account, misal. 78000XXXXXXXXXXX<br/>
                5. Pilih Benar<br/>
                6. Pilih Ya<br/>
                7. Ambil bukti bayar Anda<br/>
                8. Transaksi Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>SMS Banking</strong><br/>
                Panduan Bayar<br/>
                1. Klik App Maybank SMS Banking<br/>
                2. Input Passcode (Jika ada)<br/>
                3. Pilih Media Koneksi : SMS, USSD Atau Data (lihat indikator koneksi pada pojok kanan atas)<br/>
                4. Menu Utama, Klik Icon Transfer<br/>
                5. Pilih Virtual Account<br/>
                6. Pada kolom Rekening Sumber, masukkan rekening sumber (Pada media koneksi USSD tidak diperlukan)<br/>
                7. Pada kolom Jumlah, Masukkan jumlah yang akan di bayarkan<br/>
                8. Pada kolom No Ref/Berita, masukkan No Ref/Berita<br/>
                9. Pada kolom Rekening Tujuan, Masukkan Nomor Virtual Account (78000XXXXXXXXXXX)<br/>
                10. Klik tombol Kirim<br/>
                11. Masukkan PIN yang dikirim melalui SMS<br/>
                12. Transaksi Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Rekening dan Transaksi<br/>
                3. Pilih Maybank Virtual Account<br/>
                4. Pilih Sumber Tabungan<br/>
                5. Input Nomor Virtual Account, misal. 78000XXXXXXXXXXX<br/>
                6. Input Nominal, misal. 10000<br/>
                7. Klik Submit<br/>
                8. Input SMS Token<br/>
                9. Bukti bayar ditampilkan<br/>
                10. Transaksi Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BBBA" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>Permata Bank</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Transaksi Lainnya<br/>
                3. Pilih Pembayaran<br/>
                4. Pilih Pembayaran Lain-lain<br/>
                5. Pilih Virtual Account<br/>
                6. Input Nomor Virtual Account, misal. 8625XXXXXXXXXXXX<br/>
                7. Select Benar<br/>
                8. Select Ya<br/>
                9. Ambil bukti bayar anda<br/>
                10. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Mobile Banking<br/>
                2. Pilih Pembayaran Tagihan<br/>
                3. Pilih Virtual Account<br/>
                4. Input Nomor Virtual Account, misal. 8625XXXXXXXXXXXX sebagai No. Virtual Account<br/>
                5. Input Nominal misal. 10000<br/>
                6. Klik Kirim<br/>
                7. Input Token<br/>
                8. Klik Kirim<br/>
                9. Bukti bayar akan ditampilkan<br/>
                10. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Pembayaran Tagihan<br/>
                3. Pilih Virtual Account<br/>
                4. Input Nomor Virtual Account, misal. 8625XXXXXXXXXXXX sebagai No. Virtual Account<br/>
                5. Input Nominal misal. 10000<br/>
                6. Klik Kirim<br/>
                7. Input Token<br/>
                8. Klik Kirim<br/>
                9. Bukti bayar akan ditampilkan<br/>
                10. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="HNBN" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>Keb Hana</strong></h2></legend>
        
            <div className="col-md-6 col-sm-6" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Pembayaran<br/>
                3. Pilih Lainnya<br/>
                4. Input Nomor Virtual Account, misal. 9772XXXXXXXXXXXX<br/>
                5. Pilih Benar<br/>
                6. Pilih Ya<br/>
                7. Ambil bukti bayar Anda<br/>
                8. Selesai<br/>
            </div>
            <div className="col-md-6 col-sm-6" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih menu Transfer kemudian Pilih Withdrawal Account Information<br/>
                3. Pilih Account Number anda<br/>
                4. Input Nomor Virtual Account, misal. 9772XXXXXXXXXXXX<br/>
                5. Input Nominal, misal. 10000<br/>
                6. Click Submit<br/>
                7. Input SMS Pin<br/>
                8. Bukti bayar akan ditampilkan<br/>
                9. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BRIN" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>BRI</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Transaksi Lain<br/>
                3. Pilih Menu Pembayaran<br/>
                4. Pilih Menu Lain-lain<br/>
                5. Pilih Menu BRIVA<br/>
                6. Masukkan Nomor Virtual Account, misal. 88788XXXXXXXXXXX<br/>
                7. Pilih Ya<br/>
                8. Ambil bukti bayar anda<br/>
                9. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login BRI Mobile<br/>
                2. Pilih Mobile Banking BRI<br/>
                3. Pilih Menu Pembayaran<br/>
                4. Pilih Menu BRIVA<br/>
                5. Masukkan Nomor Virtual Account, misal. 88788XXXXXXXXXXX<br/>
                6. Masukkan Nominal misal. 10000<br/>
                7. Klik Kirim<br/>
                8. Masukkan PIN Mobile<br/>
                9. Klik Kirim<br/>
                10. Bukti bayar akan dikirim melalui sms<br/>
                11. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Pembayaran<br/>
                3. Pilih BRIVA<br/>
                4. Masukkan Nomor Virtual Account, misal. 88788XXXXXXXXXXX<br/>
                5. Klik Kirim<br/>
                6. Masukkan Password<br/>
                7. Masukkan mToken<br/>
                8. Klik Kirim<br/>
                9. Bukti bayar akan ditampilkan<br/>
                10. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BNIA" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>CIMB</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM</strong><br/>
                Panduan Bayar<br/>
                1. Input kartu ATM dan PIN Anda<br/>
                2. Pilih Menu Pembayaran<br/>
                3. Pilih Menu Lanjut<br/>
                4. Pilih Menu Virtual Account<br/>
                5. Masukkan Nomor Virtual Account, misal. 5919XXXXXXXXXXXX<br/>
                6. Pilih Proses<br/>
                7. Data Virtual Account akan ditampilkan<br/>
                8. Pilih Proses<br/>
                9. Ambil bukti bayar anda<br/>
                10. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Mobile Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Go Mobile<br/>
                2. Pilih Menu Transfer<br/>
                3. Pilih Menu Transfer ke CIMB Niaga Lain<br/>
                4. Pilih Sumber Dana yang akan digunakan<br/>
                5. Masukkan Nomor Virtual Account, misal. 5919XXXXXXXXXXXX<br/>
                6. Masukkan Nominal misal. 10000<br/>
                7. Klik Lanjut<br/>
                8. Data Virtual Account akan ditampilkan<br/>
                9. Masukkan PIN Mobile<br/>
                10. Klik Konfirmasi<br/>
                11. Bukti bayar akan dikirim melalui sms<br/>
                12. Selesai<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking</strong><br/>
                Panduan Bayar<br/>
                1. Login Internet Banking<br/>
                2. Pilih Bayar Tagihan<br/>
                3. Rekening Sumber - Pilih yang akan Anda digunakan<br/>
                4. Jenis Pembayaran - Pilih Virtual Account<br/>
                5. Untuk Pembayaran - Pilih Masukkan Nomor Virtual Account<br/>
                6. Nomor Rekening Virtual, misal. 5919XXXXXXXXXXXX<br/>
                7. Isi Remark Jika diperlukan<br/>
                8. Klik Lanjut<br/>
                9. Data Virtual Account akan ditampilkan<br/>
                10. Masukkan mPIN<br/>
                11. Klik Kirim<br/>
                12. Bukti bayar akan ditampilkan<br/>
                13. Selesai<br/>
            </div>
        </div>
    </div>
</div>
</div>

<div id="BDIN" style={{display:"none"}}>
<div className="container-wrap">
    <div className="text-content rte">
    
        <div className="row row-sm" style={{padding:"3%"}}>
        <legend><h2><strong>Danamon</strong></h2></legend>
        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM Bank Danamon menggunakan Kartu Bank Danamon</strong><br/>
                Panduan Bayar<br/>
                1. Input PIN ATM Anda<br/>
                2. Pilih Menu Pembayaran {`>>>`} Virtual Account<br/>
                3. Masukan nomor Virtual Account<br/>
                4. Masukkan Nominal<br/>
                5. Pada layar konfirmasi pembayaran, pastikan transaksi sudah benar {`->`} pilih Ya untuk memproses transaksi<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Aplikasi D-Mobile</strong><br/>
                Panduan Bayar<br/>
                1. Login pada Aplikasi D-Mobile<br/>
                2. Pilih menu Virtual Account<br/>
                3. Masukan 16 digit nomor virtual account<br/>
                4. Masukan Nominal<br/>
                5. Pada layar konfirmasi pembayaran, pastikan transaksi sudah benar {`->`} pilih Ya untuk memproses transaksi.<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM Bank Danamon menggunakan kartu Bank Lain</strong><br/>
                Panduan Bayar<br/>
                1. Masuk ke menu transfer<br/>
                2. Pilih tujuan rekening Bank Danamon<br/>
                3. Masukkan Kode Bank Danamon (011) + 16 digit nomor Virtual Account<br/>
                4. Masukkan nominal pembayaran<br/>
                5. Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat<br/>
                6. Konfirmasi pembayaran<br/>
            </div>
        </div>
        <div className="row row-sm" style={{padding:"3%"}}>        
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM Bank lain menggunakan kartu Bank Danamon atau Bank lain</strong><br/>
                Panduan Bayar<br/>
                1. Masuk ke menu transfer
                2. Pilih tujuan rekening bank lain (Online Transfer)<br/>
                3. Masukkan Kode Bank Danamon (011) + 16 digit nomor Virtual Account<br/>
                4. Masukkan nominal pembayaran<br/>
                5. Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat<br/>
                6. Konfirmasi pembayaran<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>Internet Banking Bank lain, Transfer Online (ATM Bersama / ALTO / Prima)</strong><br/>
                Panduan Bayar<br/>
                1. Masuk ke menu transfer ke bank lain<br/>
                2. Pilih transfer online<br/>
                3. Pilih Bank tujuan, Bank Danamon<br/>
                4. Masukkan 16 digit nomor Virtual Account<br/>
                5. Masukkan nominal pembayaran<br/>
                6. Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat<br/>
                7. Konfirmasi pembayaran<br/>
            </div>
            <div className="col-md-4 col-sm-4" style={{padding:"2%"}}>
                <strong>ATM Bank Danamon menggunakan kartu Bank Lain</strong><br/>
                Panduan Bayar<br/>
                1. Masuk ke menu transfer<br/>
                2. Pilih tujuan rekening Bank Danamon<br/>
                3. Masukkan Kode Bank Danamon (011) + 16 digit nomor Virtual Account<br/>
                4. Masukkan nominal pembayaran<br/>
                5. Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat<br/>
                6. Konfirmasi pembayaran<br/>
            </div>
        </div>
    </div>
</div>
</div>
        </div>
    );
}

export default PaymentInfo;